<template>
  <el-card class="im-right">
    <div class="flex-row head-wrap">
      <div class="flex-row user-wrap">
        <el-avatar class="user-header" :size="60">
          <span>{{ customerName }}</span>
          <!-- <img src="../../assets/images/defaultUser.png" alt="" /> -->
        </el-avatar>
        <div>
          <p>{{ dialogProps.name }}</p>
        </div>
      </div>
      <i class="el-icon-circle-close head-close" @click="onClose()"></i>
    </div>
    <div class="im-msg flex-grow">
      <div class="ws-im-dialog" id="wsDialog">
        <div class="" v-for="(item, index) in msgList" :key="index">
          <!-- 禁止使用=== 全等 -->
          <div style="padding: 5px"></div>
          <div class="flex-row" v-if="item.fromId != msgData.fromId">
            <div class="im-headpic-left">
              <el-avatar :size="40">
                <span>{{ customerName }}</span>
                <!-- <img src="../../assets/images/defaultUser.png" alt="" /> -->
              </el-avatar>
            </div>
            <div>
              <p class="msg-box-time"></p>
              <p class="msg-box-text-left" v-if="item.messageType === '0'">
                {{ item.content }}
              </p>
              <p class="msg-box-image msg-box-border-left" v-if="item.messageType === '1'">
                <el-image style="width: auto; height: auto" :src="jsonObj(item.extend, 'url')" fit="fill" />
              </p>
              <p class="msg-box-text-left msg-box-border-left" v-if="item.messageType === '2'">
                <wsDownfile :url="jsonObj(item.extend, 'url')" :name="jsonObj(item.extend, 'fileName')">
                  <i class="el-icon-download"></i>
                  {{ jsonObj(item.extend, "fileName") }}
                </wsDownfile>
              </p>
              <!-- <div v-if="item.messageType === '3'" class="right-im-box">
                <div class="zcl-im">
                  <div class="zcl-l">
                    <img :src="item.extend.pictureUrl" alt="" />
                  </div>
                  <div class="zcl-r">
                    <div class="p1">{{ item.extend.goodsName }}</div>
                    <div class="p2">价格：{{ item.extend.price }}</div>
                  </div>
                </div>
              </div> -->
            </div>
            <div class="flex-grow" style="min-width: 20%"></div>
          </div>
          <div class="flex-row" v-if="item.fromId == msgData.fromId">
            <div class="flex-grow" style="min-width: 20%"></div>
            <div>
              <p class="msg-box-time"></p>
              <p class="msg-box-text-right" v-if="item.messageType === '0'">
                {{ item.content }}
              </p>
              <p class="msg-box-image msg-box-border-right" v-if="item.messageType === '1'">
                <el-image style="width: auto; height: auto" :src="jsonObj(item.extend, 'url')" fit="fill" />
              </p>
              <p class="msg-box-text-right msg-box-border-right" v-if="item.messageType === '2'">
                <wsDownfile :url="jsonObj(item.extend, 'url')" :name="jsonObj(item.extend, 'fileName')">
                  <i class="el-icon-download"></i>
                  {{ jsonObj(item.extend, "fileName") }}
                </wsDownfile>
              </p>
            </div>
            <div class="im-headpic-right">
              <el-avatar style="display: flex" :size="40">
                <img style="margin: auto" src="../../assets/images/favicon.png" />
              </el-avatar>
            </div>
          </div>
          <div style="padding: 5px"></div>
        </div>
      </div>
    </div>
    <div class="im-box">
      <div class="im-upload flex-row">
        <el-upload
          class="editor-slide-upload"
          action="https://oytqc-oss.oss-cn-qingdao.aliyuncs.com"
          :show-file-list="false"
          :data="imgDataObj"
          :file-list="imgFileList"
          :on-success="handleImgSuccess"
          :before-upload="beforeImgUpload"
          :accept="imgFormat"
        >
          <i class="el-icon-picture-outline"></i>
        </el-upload>
        <el-upload action="/" :http-request="uploadFile" :accept="fileFormat" :show-file-list="false">
          <i class="el-icon-folder-opened"></i>
        </el-upload>
        <div v-loading="uploadLoading" class="upload-loading" element-loading-spinner="el-icon-loading"></div>
      </div>
      <div class="im-send-box">
        <el-input
          v-model="messageContent"
          class="im-send-input"
          type="textarea"
          resize="none"
          style="border: none; background: none"
          @keyup.enter="mineSend()"
        ></el-input>
      </div>
      <div class="im-send-btn-box">
        <el-button class="send-btn" @click="mineSend()">发送</el-button>
      </div>
    </div>
  </el-card>
</template>
<script>
import { WsRequest } from "./wsRequest";
import wsDownfile from "./ws-downfile.vue";
import Oss from "../../assets/js/oss.js";
export default {
  components: {
    wsDownfile,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    dialogProps: {
      type: Object,
      default: () => {
        return {};
      },
    },
    curUserId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      wssUrl: `${process.env.VUE_APP_VITE_WSS}?token=`,
      imgFormat: ".jpg, .jpeg, .png, .gif",
      fileFormat: ".doc, .docx, .xls, .xlsx, .pdf, .gif, .exe, .msi, .swf, .sql, .apk, .psd",
      msgList: [], //消息列表
      messageContent: undefined, //消息内容
      // mainPic: store.getters.avatar, //我的头像
      ws: new WsRequest(),
      msgData: {
        chatId: this.dialogProps.id, //对方id
        fromId: this.curUserId, //我的id
        fromType: "1",
      },
      imgDataObj: {
        policy: "",
        signature: "",
        key: "",
        ossaccessKeyId: "",
        dir: "",
        host: "",
        timeStamp: "",
      },
      imgFileList: [],
      listObj: {},
      uploadLoading: false,
    };
  },
  computed: {
    customerName() {
      return this.dialogProps.name ? this.dialogProps.name.slice(0, 2) : "";
    },
  },
  methods: {
    apiImMessage(query) {
      return this.$http.get("im/messages", { params: query });
    },
    getAttachment(str) {
      if (str != null && str.length > 0) {
        return JSON.parse(str);
      }
      return [];
    },
    async uploadFile(file) {
      this.uploadLoading = true;
      let formdata = new FormData();
      formdata.append("file", file.file);
      const { data: res } = await this.$http.post("cmUser/message/uploadFile", formdata, { headers: { isCurLoad: true } });
      this.uploadLoading = false;
      if (res.code === 200) {
        let { fileName, filePath } = res.data;
        let extend = {
          fileName,
          url: filePath,
        };
        this.mineSend("2", extend);
      } else {
        this.$message.error("上传失败");
      }
    },
    handleImgSuccess(_, file) {
      Oss.imgSuccess(file, this.listObj, this.imgDataObj);
      this.$nextTick(() => {
        let extend = {
          fileName: file.name,
          url: this.listObj[file.uid].url,
        };
        this.mineSend("1", extend);
      });
    },
    beforeImgUpload(file) {
      this.uploadLoading = true;
      const _self = this;
      const fileName = file.uid;
      this.listObj[fileName] = {};
      return new Promise((resolve, reject) => {
        _self.$http
          .get("aliyun/oss/policy")
          .then((response) => {
            var num = ""; //定义编号
            for (
              var i = 0;
              i < 4;
              i++ //4位随机数，用以加在时间戳后面。
            ) {
              num += Math.floor(Math.random() * 10);
            }
            num = new Date().getTime() + num; //时间戳，用来生成编号。
            _self.imgDataObj.policy = response.data.data.policy;
            _self.imgDataObj.signature = response.data.data.signature;
            _self.imgDataObj.ossaccessKeyId = response.data.data.accessKeyId;
            _self.imgDataObj.key = response.data.data.dir + "/bad/" + num + "${filename}";
            _self.imgDataObj.dir = response.data.data.dir + "/bad";
            _self.imgDataObj.host = response.data.data.host;
            _self.imgDataObj.timeStamp = num;
            file.timeStamp = num;
            Oss.imgCompress(file, this.listObj, resolve, reject);
          })
          .catch(() => {
            reject(false);
          })
          .finally(() => {
            this.uploadLoading = false;
          });
      });
    },
    onClose() {
      this.$emit("input", false);
    },
    setScroll() {
      setTimeout(() => {
        let wsDialog = document.getElementById("wsDialog");
        let a = 295 + Number(wsDialog?.scrollHeight);
        wsDialog?.scrollTo(0, a);
      }, 200);
    },
    initMsg() {
      const token = window.sessionStorage.getItem("tokenValue");
      this.ws.init(
        //wss://www.manseki.shop/wss
        this.wssUrl + token
      );
      this.ws.onmessage = (message) => {
        console.log("message", message);
        //群聊里面，自己发的消息不再显示
        console.log("自己的id", this.msgData.fromId);
        console.log("----", this.msgData);
        const { fromId, chatId } = this.msgData;
        if (fromId == message.fromId && chatId == message.chatId) {
          //自己发送的消息
          this.msgList.push(message);
        }
        if (fromId == message.chatId && chatId == message.fromId) {
          //对方发的消息
          this.msgList.push(message);
        }
        this.setScroll();
      };
    },
    mineSend(messageType = "0", extend = undefined) {
      if (this.messageContent || extend) {
        let msg = {
          messageType: messageType,
          chatId: this.msgData.chatId,
          fromId: this.msgData.fromId,
          mine: true,
          timestamp: new Date().getTime(),
          content: this.messageContent,
          extend: extend,
          type: "0", //chat.value.type || '111'
          fromType: "1",
        };
        this.ws.sendMessage(msg);
        this.messageContent = undefined;
      }
      this.setScroll();
    },
    jsonObj(json, key) {
      if (json) {
        if (typeof json === "string") {
          let a = JSON.parse(json);
          return a[key];
        } else {
          return json[key];
        }
      } else {
        return "";
      }
    },
    getMsgList() {
      let params = {
        chatId: this.msgData.chatId,
        fromId: this.msgData.fromId,
        fromType: "1",
      };
      this.apiImMessage(params).then(({ data: res }) => {
        if (res.code === 200) {
          this.msgList = res?.data?.records || res?.data;
          this.setScroll();
        }
      });
    },
  },
  mounted() {
    this.initMsg();
    this.getMsgList();
  },
  destroyed() {
    this.ws.close();
  },
};
</script>
<style scoped lang="less">
@import url(./style.css);
.right-im-box {
  width: 610px;
  margin-top: 100px;
  position: relative;
  // .zcl-im {
  //   position: absolute;
  //   border-radius: 15px;
  //   top: -86px;
  //   left: 0;
  //   width: 100%;
  //   padding: 10px 20px 10px 10px;
  //   box-sizing: border-box;
  //   display: flex;
  //   align-items: center;
  //   background-color: #7dc647;
  //   z-index: 99;
  //   .zcl-l {
  //     img {
  //       width: 50px;
  //       height: 60px;
  //       margin-top: 2px;
  //     }
  //   }
  //   .zcl-r {
  //     margin-left: 15px;
  //     color: #fff;
  //     margin-top: -5px;
  //     .p1 {
  //       line-height: 1.4em;
  //       display: -webkit-box;
  //       overflow: hidden;
  //       text-overflow: ellipsis;
  //       -webkit-line-clamp: 2; /* 限定最多显示两行 */
  //       -webkit-box-orient: vertical;
  //     }
  //     .p2 {
  //       margin-top: 8px;
  //       line-height: 1em;
  //       color: #ff0000;
  //       display: flex;
  //       align-items: center;
  //       justify-content: space-between;
  //       span {
  //         color: #ff9900;
  //         cursor: pointer;
  //       }
  //     }
  //   }
  //   .zcl-icon {
  //     position: absolute;
  //     top: 12px;
  //     right: 8px;
  //     cursor: pointer;
  //   }
  // }
}

.head-wrap {
  border-bottom: 1px solid #ccc;
  padding-bottom: 10px;
  position: relative;
  .user-wrap {
    align-items: center;
  }
  .user-header {
    margin-right: 10px;
  }
  .head-close {
    position: absolute;
    right: 10px;
    top: 0px;
    font-size: 30px;
    color: #bababa;
    cursor: pointer;
  }
}

.el-input--medium /deep/ .el-input__inner {
  border: none;
}

.im-send-box {
  height: 100px;
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  .im-send-input {
    border: none;
    ::v-deep .el-textarea__inner {
      padding: 0 15px 5px 0;
      border: none;
      height: auto;
    }
    ::v-deep .el-textarea__inner::-webkit-scrollbar {
      width: 4px;
    }
    ::v-deep .el-textarea__inner::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: #bababa;
      opacity: 0.2;
    }
  }
}

.im-msg {
  background-color: #f3f3f3;
  .im-headpic-left {
    margin-right: 5px;
  }
  .im-headpic-right {
    margin-left: 5px;
  }
  .msg-box-time {
    padding: 5px 0;
  }
  .msg-box-text-right {
    border: 1px solid #89d961;
    color: #000;
    background: #89d961;
  }
  .msg-box-text-left {
    border: 1px solid #fff;
    background-color: #fff;
    color: #000;
  }
  .ws-im-dialog {
    padding: 0 10px;
  }
}
</style>
